import { Group, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { IndicatorStandards as IndicatorStandardsData } from 'types/lcms/courses';
import LoadingText from './LoadingText';
import { labelMapping } from 'constant/course';
import { InputInformation } from '../courses/InputInformation';
import { useQuery } from '@tanstack/react-query';
import { courseService } from 'services/lcms/course.service';

interface IndicatorStandardsProps {
  data?: IndicatorStandardsData;
  loading?: boolean;
}

const IndicatorStandards: React.FC<IndicatorStandardsProps> = ({ data, loading }) => {
  const { data: dataPassingFormula, isPending } = useQuery({
    queryKey: ['getPassingFormula'],
    queryFn: () =>
      courseService.getPassingFormula({
        pageSize: 1000,
        pageNumber: 1
      }),
    staleTime: Infinity
  });

  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineDocumentText />
          <Text c={'dark'} fw={700}>
            Indicator & Standards
          </Text>
        </Group>
        {loading && <LoadingText />}
        {!loading && data && (
          <>
            {Object.keys(data).map((key, i) => {
              if (key === 'liaIndicator' || key === 'limIndicator') {
                return (
                  <Stack gap={4} key={i}>
                    <Text c={'dark'} fw={600} fz={14}>
                      {labelMapping[key] || key}
                    </Text>

                    <Text fz={14} c={'secondary'}>
                      {data[key as keyof typeof data] ? 'Yes' : 'No'}
                    </Text>
                  </Stack>
                );
              }
              if (key === 'passingFormula') {
                return (
                  <Stack gap={0} key={i}>
                    <Text c={'dark'} fw={600} fz={14}>
                      Passing Formula
                    </Text>
                    <Text fz={14} c={'dark'}>
                      {!isPending && data?.passingFormula ? (
                        <Group align='center' gap={0}>
                          <Text fz={14} c={'dark'}>
                            Formula {data.passingFormula}
                          </Text>
                          <InputInformation
                            description={
                              dataPassingFormula?.data?.find(
                                (formula: { option: string }) =>
                                  formula.option === data.passingFormula
                              )?.optionDesc as string
                            }
                          />
                        </Group>
                      ) : (
                        '-'
                      )}
                    </Text>
                  </Stack>
                );
              }
              if (key === 'formulaID') {
                return null;
              }
              if (key === 'c') {
                return (
                  <Stack gap={0} key={i}>
                    <Group gap={0}>
                      <Text c={'dark'} fw={600} fz={14}>
                        Bloom`s Taxonomy
                      </Text>
                      <InputInformation description='Bloom`s Taxonomy Measurement Level' />
                    </Group>
                    <Text fz={14} c={'dark'}>
                      {data?.c || '-'}
                    </Text>
                  </Stack>
                );
              }
              return (
                <Stack gap={4} key={i}>
                  <Text c={'dark'} fw={600} fz={14}>
                    {labelMapping[key] || key}
                  </Text>

                  <Text fz={14} c={'secondary'}>
                    {data[key as keyof typeof data] || '-'}
                  </Text>
                </Stack>
              );
            })}
          </>
        )}
      </Stack>
    </Card>
  );
};

export default IndicatorStandards;
